import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import DefaultFormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const jypSessionChoices = [
  {
    value: 'MONSOON',
    label: 'Monsoon',
  },
  {
    value: 'WINTER',
    label: 'Winter',
  },
  {
    value: 'BUDGET',
    label: 'Budget',
  },
];

class SessionSelector extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    initialValue: PropTypes.string,
  };

  static defaultProps = {
    onChange: () => {},
    initialValue: '',
  };

  state = {
    sessionSelected: this.props.initialValue || 'MONSOON',
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.sessionSelected !== prevState.sessionSelected) {
      this.props.onChange(this.state.sessionSelected);
    }
  }

  render() {
    return (
      <FormControl>
        <InputLabel htmlFor="jyp-cities">JYP Session</InputLabel>
        <Select
          value={this.state.sessionSelected}
          onChange={(event) => {
            this.setState({ sessionSelected: event.target.value });
          }}
        >
          {jypSessionChoices.map(session => (
            <MenuItem key={session.value} value={session.value}>
              {session.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

export default SessionSelector;

const FormControl = styled(DefaultFormControl)`
  && {
    min-width: 200px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/SessionSelector/SessionSelector.js